import "./carousel.css";
import { Box, Grid2, useTheme } from "@mui/material";
import ThumbnailSlider from "./ThumbnailSlider";
import CustomImageViewer from "./CustomImageViewer";
import { useCarousel } from "../../hooks/carousel/useCarousel";
import MainDisplay from "./MainDisplay";
import { CarouselContext } from "../../context/CarouselContext";


interface CarouselProps {
  images: any[];
}

const Carousel: React.FC<CarouselProps> = ({ images }) => {
  const theme = useTheme();

  const carouselState = useCarousel(images);
  const { uniqueImageTypes, selectedType, filteredImages } = carouselState

  const isUcOnly = ((uniqueImageTypes.length === 1 && ["img_uc_dewarp", "img_uc"].includes(filteredImages[0]?.imageType || '')) ||
    (uniqueImageTypes.length > 1 && ["img_uc_dewarp", "img_uc"].includes(selectedType)));


  return (
    <CarouselContext.Provider value={carouselState}>
      <Box sx={{
        width: "100%",
        height: "100%",
        minHeight: "400px",
        margin: "0 auto",
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        p: "20px 10px",
        borderRadius: 2,
        overflow: 'hidden',
      }}>
        <Grid2 container justifyContent="center" sx={{ height: "100%" }}>
          {filteredImages.length > 0 &&
            <MainDisplay/>
          }
          {!isUcOnly && (
            <ThumbnailSlider />
          )}
        </Grid2>
        <CustomImageViewer />
      </Box>
    </CarouselContext.Provider>
  );
};

export default Carousel;
